module.exports = __webpack_public_path__ + "彭宗欣-9e71be39.png";